// extracted by mini-css-extract-plugin
export default {"imageGallery":"MyGallery_imageGallery__B1I5I","imageGalleryImg":"MyGallery_imageGalleryImg__NCosx"};